export const RECIPE_BRANDS = ["proteingarden", "dinas", "shared"];

export function recipeBrandLabel(brand) {
  if (brand === "proteingarden") return "Protein Garden";
  if (brand === "dinas") return "Dinas";
  if (brand === "shared") return "Shared";
  return brand || "—";
}

export function recipeBrandBadgeStyle(brand) {
  if (brand === "proteingarden") return { background: "#DCFCE7", color: "#166534" };
  if (brand === "dinas") return { background: "#EDE9FE", color: "#5B21B6" };
  if (brand === "shared") return { background: "#F3F4F6", color: "#4B5563" };
  return { background: "var(--surface2)", color: "var(--text-secondary)" };
}

export async function recipesApiError(res, fallback) {
  try {
    const data = await res.json();
    if (typeof data?.detail === "string") return data.detail;
    if (Array.isArray(data?.detail)) return data.detail.map((d) => d.msg || String(d)).join("; ");
  } catch {
    /* ignore */
  }
  return fallback;
}

export function formatRecipeDate(iso, lang) {
  if (!iso) return null;
  try {
    const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
    if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
    return d.toLocaleDateString(lang === "gr" ? "el-GR" : "en-GB");
  } catch {
    return String(iso).slice(0, 10);
  }
}

export const EMPTY_RECIPE_FORM = {
  canonical_name: "",
  brand: "proteingarden",
  vessel: "",
  raw_weight_grams: "",
  cooked_weight_grams: "",
};

export const EMPTY_ALIAS_FORM = {
  alias_name: "",
  recipe_master_id: "",
  is_reheat: false,
};
